import React from 'react'
import { ShortcutKbd } from '@/components/ui/shortcut-kbd'
import { MobileMenuSection } from './mobile-menu-section'
import { StyledMenuItem } from './styled-menu-items'

export const MobileHelpSection: React.FC = () => {
  return (
    <MobileMenuSection value="help" label="Help">
      <StyledMenuItem>About</StyledMenuItem>
      <StyledMenuItem>Help</StyledMenuItem>
      <StyledMenuItem>Contact Support</StyledMenuItem>
      <StyledMenuItem>
        Shortcuts
        <ShortcutKbd shortcutKey="shortcuts" />
      </StyledMenuItem>
    </MobileMenuSection>
  )
}
